import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-message-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})
export class MessagePopupComponent {
  public dialogData: any;

  public implantDetails: any;

  constructor(
    public dialogRef: MatDialogRef<MessagePopupComponent>,
    public dialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    const blobLink = document.getElementById('blob-link');

    if (blobLink) {      
      const url = window.URL.createObjectURL(this.dialogData.blob);
      blobLink.setAttribute('href', url);
      blobLink.setAttribute('download', this.dialogData.fileName);
      blobLink.click();
    }
    
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
